module.exports = __webpack_public_path__ + "static/media/signal-alt-2.195bed3f.svg";